export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const DummyImage = require("../assets/theme_card_icon.png")
export const themeImg = require("../assets/themeImg.png");
export const attch = require("../assets/attachment.png");
